import React from "react";
import Lottie from 'lottie-react';
import animationData from './logo-lottie.json';

export default function LogoAnimation() {
  return (
    <div className="w-64 h-64 mx-auto">
     <Lottie
       animationData={animationData}
       autoplay
       loop={false}
       style={{ width: '100%', height: '100%' }}
     />
  </div>
  );
}